module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-900.412c6f01.woff";